import React from 'react';
import { displayName } from '../../../../App';
import Content from '../../../components/Pages/MessageManager/Builder';
import MainInfoTracLayout from '../../../components/Layout/Main';

function MessageManagerBuilder() {
  document.title = `${displayName}: Message Manager Builder`;

  return (
    <MainInfoTracLayout>
      <Content />
    </MainInfoTracLayout>
  );
}

export default MessageManagerBuilder;
